import React, { useEffect, useState } from "react";
import SwaggerUI from "swagger-ui-react"
import {fetchData} from "../utils/helpsers";
import Box from '@mui/material/Box';
import CircularProgress from "@mui/material/CircularProgress";

function SwaggerPage() {
  const [apiData, setApiData] = useState();

  useEffect(()=> {
    const fetchController = new AbortController();
    fetchData({
      endpoint: `${process.env.REACT_APP_API_URL}/`,
      controller: fetchController
    }).then( res => {
      let resData = res.data;
      resData.host = (process.env.REACT_APP_API_URL).replace('https://', '')
      resData.schemes = ['https']
      resData['securityDefinitions'] = {
        "bearerAuth": {
          "name": "Authorization",
          "in": "header",
          "type": "apiKey",
          "description": "Enter the token with the `Bearer` prefix, e.g. \"Bearer abcde12345\"."
        }
      }
      resData['security'] = [ { "bearerAuth": [] } ]
      setApiData(resData)
    })
    // Cleaning component.
    return function cleanup() {
      fetchController?.abort("Unmounted SwaggerUI component");
    }
  },[])

  return (
    apiData
      ? <SwaggerUI spec={apiData}/>
      : <Box sx={{ display:'flex', justifyContent: 'center', marginTop: '10px'}}>
          <CircularProgress size={80} />
        </Box>

  )
}

export default SwaggerPage
